import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TenantsService } from 'src/app/services/api/tenants.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VerticalMenuItem } from 'src/app/models/vertical-menu/vertical-menu-item';
import { Endpoint } from 'src/app/models/endpoint';
import { EndpointType } from 'src/app/models/endpoint-type';
import { Principal } from 'src/app/models/principal/principal';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Authority } from 'src/app/models/principal/authority';
import { RouterSegments } from 'src/app/models/router-segments';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
private destroyRef = inject(DestroyRef);
  breadcrumbItems: BreadcrumbItem[];
  principal: Principal;
  tenant: string;

  verticalMenuItems: VerticalMenuItem[];

  keycloakEndpoint: Endpoint;
  gitlabEndpoint: Endpoint;
  principalAbbreviation: string;

  instancelength: any = {};
  auth = false;
  region = false;
  profile = true;
  tenantRegion: any;

  constructor(private authService: AuthService, private tenantsService: TenantsService, private instancesService: InstancesService,
     private toastrService: ToastrService, private readonly titleService: Title, private readonly route: ActivatedRoute,
     private router: Router) {
  }

  ngOnInit(): void {
    this.principal = this.authService.principal;
    if (!this.principal?.authorities?.find((item) => item === Authority.OPERATION_MANAGER || item === Authority.SERVICE_MANAGER)) {
      this.router.navigate(['/', this.authService.principal.provider]);
    }

    this.titleService.setTitle(this.route.snapshot.data.title);
    this.loadData();
    this.configureBreadcrumb();
    this.configureVerticalMenu();
    this.principal = this.authService.principal;
    this.principalAbbreviation = this.getNameAbbreviation(this.authService.principal);
    this.loadInstances();

  }

  onCopiedUrl(): void {
    this.toastrService.clear();
    this.toastrService.checkboxMessage(
      `${'Copied'}`
      );
  }

  showEvents(e): void {
    if (translate(e.nameKey) === 'Authentication Management') {
      this.auth = true;
      this.profile = false;
      this.region = false;
    } else if (translate(e.nameKey) === 'Profile') {
      this.profile = true;
      this.auth = false;
      this.region = false;
    } else if (translate(e.nameKey) === 'Region') {
      this.profile = false;
      this.auth = false;
      this.region = true;

    }

  }

  private loadData(): void {
    this.tenant = this.authService.principal.provider;
    this.tenantsService.getTenantDetails()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tenantDetails => {
        this.tenantRegion = tenantDetails.region;
        // this.tenantRegion = tenantDetails.temenosRegion;
        // this.keycloakEndpoint = {
        //   url: tenantDetails.keycloakUrl,
        //   name: translate('SETTINGS.SOLUTION_KEYCLOAK'),
        //   useType: EndpointType.OTHER
        // };

        // this.gitlabEndpoint = {
        //   url: tenantDetails.gitlabUrl,
        //   name: translate('SETTINGS.SOLUTION_GITLAB'),
        //   useType: EndpointType.OTHER
        // };
      });
  }

  private configureBreadcrumb(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ label: translate('SETTINGS.HOME'), url: [] });
    this.breadcrumbItems.push({ label: translate('SETTINGS.SETTINGS') });
  }

  private configureVerticalMenu(): void {
    this.verticalMenuItems = [
      {
        nameKey: 'SETTINGS.PROFILE',
        icon: 'person',
        expanded: false,
        selected: true
      },
      // {
      //   nameKey: 'SETTINGS.SECURITY',
      //   icon: 'shield',
      //   expanded: false,
      //   items: [{
      //     nameKey: 'SETTINGS.AUTHENTICATION_MANAGEMENT',
      //     selected: false,
      //   }]
      // },
      {
        nameKey: 'SETTINGS.NOTIFICATION',
        icon: 'notifications',
        disabled: true,
      }, {
        nameKey: 'SETTINGS.REGION',
        icon: 'place',
        expanded: false,
        selected: false
      }];
  }

  private loadInstances(): void {
    this.instancesService.getInstances()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(instances => {
        this.instancelength = instances.length;
      });
  }

  private getNameAbbreviation(principal: Principal): string {
    // Does a possibility to not have first and last name exist?
    return principal?.attributes?.given_name.substr(0, 1).toUpperCase()
      + principal?.attributes?.family_name.substr(0, 1).toUpperCase();
  }

}
